var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCalendarTodayFilled = function SvgCalendarTodayFilled(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#111827",
    d: "M3 9h18V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#111827",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M16 2v2m0 2V4M8 2v2m0 2V4M3 6a2 2 0 0 1 2-2h3M3 6v13a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6M3 6v3h18V6m0 0a2 2 0 0 0-2-2h-3m0 0H8"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCalendarTodayFilled);
export default ForwardRef;